import { useCallback, useState } from 'react';

type StoredStateValue = string | boolean | number | object | null | undefined;

// Sync component state with session storage
// Handles non-string values and prevents re-fetching on re-render
const useSessionStorage = (key: string, defaultValue?: StoredStateValue) => {
  const [value, setValue] = useState(() => {
    const storedValue = sessionStorage.getItem(key);
    if (storedValue === null) {
      return defaultValue;
    }
    try {
      // Non-string values
      return JSON.parse(storedValue);
    } catch (e) {
      // String values
      return storedValue;
    }
  });

  const setItemValue = useCallback(
    (newValue: StoredStateValue) => {
      if (newValue === undefined || newValue === null) {
        sessionStorage.removeItem(key);
      } else {
        const storedValue =
          typeof newValue !== 'string' ? JSON.stringify(newValue) : newValue;
        sessionStorage.setItem(key, storedValue);
      }
      setValue(newValue);
    },
    [key],
  );

  return { value, setItemValue };
};

export default useSessionStorage;
